// src/components/UI/LoadingSpinner.tsx
import React from "react";
import { clsx } from "clsx";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg" | "xl";
  color?: "primary" | "white" | "gray" | "blue";
  className?: string;
  label?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "md",
  color = "primary",
  className = "",
  label,
}) => {
  const sizeClasses = {
    sm: "h-4 w-4",
    md: "h-8 w-8",
    lg: "h-12 w-12",
    xl: "h-16 w-16",
  };

  const colorClasses = {
    primary: "text-indigo-600",
    white: "text-white",
    gray: "text-gray-600",
    blue: "text-blue-600",
  };

  return (
    <div className="flex flex-col items-center justify-center">
      <div
        className={clsx(
          "animate-spin rounded-full border-2 border-solid border-current border-r-transparent",
          sizeClasses[size],
          colorClasses[color],
          className,
        )}
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
      {label && <p className="mt-3 text-sm text-gray-600">{label}</p>}
    </div>
  );
};

export default LoadingSpinner;
